import { Observable, getGlobalScope } from '@amplitude/analytics-core';
export var createMutationObservable = function () {
    return new Observable(function (observer) {
        var mutationObserver = new MutationObserver(function (mutations) {
            observer.next(mutations);
        });
        if (document.body) {
            mutationObserver.observe(document.body, {
                childList: true,
                attributes: true,
                characterData: true,
                subtree: true,
            });
        }
        return function () { return mutationObserver.disconnect(); };
    });
};
/**
 * Creates an observable that tracks click events on the document.
 * @param clickType - The type of click event to track (click or pointerdown)
 */
export var createClickObservable = function (clickType) {
    if (clickType === void 0) { clickType = 'click'; }
    return new Observable(function (observer) {
        var _a;
        var handler = function (event) {
            observer.next(event);
        };
        /* istanbul ignore next */
        (_a = getGlobalScope()) === null || _a === void 0 ? void 0 : _a.document.addEventListener(clickType, handler, { capture: true });
        return function () {
            var _a;
            /* istanbul ignore next */
            (_a = getGlobalScope()) === null || _a === void 0 ? void 0 : _a.document.removeEventListener(clickType, handler, { capture: true });
        };
    });
};
//# sourceMappingURL=observables.js.map